export default {
  placement: 'CENSUS',
  tagMaropost: 'PrePurchase_LastPage_Census'
}
